import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AppUserListReport from "../components/AppUserListReport";

const AddUserListReportPage = () => {
  return (
    <>
      {/* MasterLayout */}
        {/* Breadcrumb */}
        <Breadcrumb title='App User List' />

        {/* AddBlogLayer */}
        <AppUserListReport />
    </>
  );
};

export default AddUserListReportPage;
